"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[295],{

/***/ 35630:
/***/ ((module) => {

module.exports = {"id":"tempo"};

/***/ })

}]);